var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title-address")))]),
      _c(
        "w-card-content",
        [
          _c("div", { staticClass: "mb" }, [
            _c("p", [_c("b", [_vm._v(_vm._s(_vm.address.companyName))])]),
            _c("p", [
              _vm._v(
                _vm._s(_vm.address.firstName) +
                  " " +
                  _vm._s(_vm.address.lastName)
              ),
            ]),
            _c("p", [_vm._v(_vm._s(_vm.address.address))]),
            _c("p", [
              _vm._v(
                _vm._s(_vm.address.postal) + " " + _vm._s(_vm.address.place)
              ),
            ]),
            _c("p", { staticClass: "mts" }, [
              _vm._v(" " + _vm._s(_vm.address.tel) + " "),
            ]),
            _c("p", [_vm._v(_vm._s(_vm.address.email))]),
            _c("p", [_vm._v(_vm._s(_vm.address.vatNumber))]),
          ]),
          _c(
            "w-link",
            {
              staticClass: "mt",
              on: {
                click: function ($event) {
                  return _vm.onEditClicked()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("edit-address")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }